"use strict"


exports.filter = function(result, config, cb) {
  var err = "";


  if (config.decimals.useCoords) {
    result.meters = filterByPosition(result, config);
    result = checkMovement(result, config);
  }

  if (config.decimals.useCoords && result.meters.length !== config.decimals.positions.length){
    recoverMissingPointer(result, config)
  }

  if (!err && result.meters.length !== config.decimals.positions.length){
    err = 'meters count is wrong:' + result.meters.length;// + ' red:' + (Math.round(result.redPercentage * 1000) / 1000) + ' redTreshold:' + result.redTreshold;
    result.errorCode = 4;
  }

  if (!err) {
    err = valueCorrelation(result, config);
  }

  setTimeout(function() {
    cb(err, result);
  }, 1)
}




function checkMovement (result, config) {
// if pointers have moved or we don't find pointers at all, set meter moved to true
  if (result.meters.length > 0) {
    var allowedPointDistance = config.decimals.allowedCenterPointMove || 7;
    var allowedDistance = result.meters.length * allowedPointDistance;
    var sumVectorDistance = getSumVectorLength(result.meters);
    result.pointerMoveInPx = parseInt(sumVectorDistance / result.meters.length, 10);
    if (sumVectorDistance > allowedDistance) {
      result.meterMoved = true;
    }
  } else {
    result.meterMoved = true;
    result.pointerMoveInPx = 10000; // we do not know how much meter is moved -> make it big enough
  }
  return result;
}


/* if pointers have configured positions, we can use those to remove other position found by algorithm
currently limit for center point distance to configured center point is hard coded to 10 pixels.
*/

function filterByPosition(result, config) {
  var meters = [];
  var centerPointRadius = config.decimals.centerPointRadius || 15;
  for (var i = 0; i < config.decimals.positions.length; i++) {
    var found = false;
    var configCenter = new Vec2D(config.decimals.positions[i].coords.x, config.decimals.positions[i].coords.y);
    for (var j = 0; j < result.meters.length; j++) {
      if (configCenter.distance(result.meters[j].center) < centerPointRadius) {
        result.meters[j].diffVector = result.meters[j].center.difference(configCenter);
        result.meters[j].positionIndex = i;
        meters.push(result.meters[j]);
        found = true;
      }
    }
    if (!found && config.decimals.positions[i].hasOwnProperty('missingValue')) {
      var missingValue = config.decimals.positions[i].missingValue;
      if (meters.length > 0) { // prevent rounding errors....
        missingValue += meters[meters.length - 1].value / 10;
      }
      meters.push({value:missingValue, diffVector:{x:0,y:0}})
    }
  }
  return meters;
}

function getSumVectorLength(meters) {
  var sumVector = new Vec2D(0, 0);
  for (var i = 0; i < meters.length; i++) {
    if(meters[i].diffVector) {
      sumVector = sumVector.sum(meters[i].diffVector);
    }
  }
  return Math.abs(sumVector.distance({x:0, y:0}));
}

// for unit testing
exports.filterByPosition = filterByPosition;

function valueCorrelation(result, config) {
  var meterIndex = 0;
  var values = [];

  var err = "";

  // In perfect world value rounding should be always 0
  result.debug.valueRounding = "valueRounding:"
  for (var i = config.decimals.positions.length - 1; i > 0; i--) {
    // some meter pointer are not in sync with each other and there is need to make constant level shift
    if (!isNaN(config.decimals.positions[i].shiftValue)) {
      result.meters[i].value += config.decimals.positions[i].shiftValue;
    }

    // value correlation should be checked only if there are no "holes" in pointer config. eg: some pointer is missing
    if (config.decimals.positions[i - 1].precision * 10 == config.decimals.positions[i].precision
      && result.meters[i].value > -1 && result.meters[i - 1].value > -1) { // values should be above -1
      var value = result.meters[i].value;
      value -= (result.meters[i - 1].value / 10);
      var valueRounded = Math.round(value);
      result.debug.valueRounding += " " + config.decimals.positions[i].precision + ":" + Math.round(Math.abs(valueRounded - value) * 100) / 100;
      if (round2(Math.abs(valueRounded - value)) > 0.4) {
        err = "value rounding was above 0.4";
        result.errorCode = 3;
      }
    }
  }

  return err;
}

// for unit testing
exports.valueCorrelation = valueCorrelation;

// if one pointer is missing, try to recover it
// only least significant pointers is allowed to be recovered
// currently allowed missing pointers: 0.0001
// caveats: there should no more than 1 hole
function recoverMissingPointer(result, config) {
  if(result.meters.length <1) {
    // at least 1 result is needed for recovery
    return
  }
  if((config.decimals.positions.length - result.meters.length) > 1) {
    // too many pointers missing
    return
  }

  // fill missing meter information
  if(result.meters[0].positionIndex != 0 && config.decimals.positions[0].precision == 0.0001) {
    result.meters.splice(0, 0 , {value:-1, positionIndex: 0}); //-1 means not available
  }
  return
}

// for unit testing
exports.recoverMissingPointer = recoverMissingPointer;


// 2D VECTOR CLASS -> we need to create library for this


var Vec2D = function(x, y) {
  this.x = x;
  this.y = y;
};
// for unit testing
exports.Vec2D = Vec2D;

Vec2D.prototype.sum = function(v) {
  return new Vec2D(this.x + v.x, this.y + v.y);
};

Vec2D.prototype.difference = function(v) {
  return new Vec2D(this.x - v.x, this.y - v.y);
};

Vec2D.prototype.distance = function(v) {
  var dx = this.x - v.x, dy = this.y - v.y;
  return Math.sqrt(dx * dx + dy * dy);
};



function round2(val) {
  return Math.round(val * 100) / 100;
}

function getAngle(center, point) {
  return Math.atan2(point.y - center.y, point.x - center.x) * (180 / Math.PI) + 90; // We add 90 to translate to positive Y-axis from X-axis.
}





//////////////////
// WEBPACK FOOTER
// ./~/@smartvatten/flowone-algorithms/decimalpointers/pointer-filter.js
// module id = 837
// module chunks = 0